import { isArray, isSafeInteger } from '@sortlist-frontend/utils';

export const MIN_BUDGET = 1000;
export const MAX_BUDGET = 1000000;

export const getDefaultBudget = () => {
  return [MIN_BUDGET, MAX_BUDGET];
};

export const transformServiceBudgetIfNull = (budget: number[]) => {
  if (!budget) return getDefaultBudget();
  if (!isArray(budget)) return getDefaultBudget();
  if (budget.length == 0) return getDefaultBudget();
  if (budget.length == 1) return [budget[0] || MIN_BUDGET, MAX_BUDGET];

  const min = budget[0] && isSafeInteger(budget[0]) ? budget[0] : MIN_BUDGET;
  const max = budget[1] && isSafeInteger(budget[1]) ? budget[1] : MAX_BUDGET;
  return [min, max];
};
